import React from 'react';
import type { ComponentType } from 'react';

import { BoxProps } from '@rbilabs/universal-components';

import { useRoute } from 'hooks/navigation/use-route';
import { useEnableProductDetailsPageRedesign } from 'pages/menu/hooks/use-enable-product-details-page-redesign';
import { useMobileFooterComponent } from 'state/mobile-footer';
import { UUID_REGEX_STRING } from 'utils/constants';
import { routes } from 'utils/routing';

export type LayoutBottomContainerProps = BoxProps;

const LayoutBottomContainer: ComponentType<React.PropsWithChildren<LayoutBottomContainerProps>> = ({
  children,
  ...props
}) => {
  const { pathname } = useRoute();
  const footerComponent = useMobileFooterComponent();

  const shouldSkipProductDetailsPage = useEnableProductDetailsPageRedesign();

  const mobileRoutesWithoutBottomNavbar = [
    routes.cart,
    routes.rewardsOnboarding,
    routes.signUp,
    routes.partnerships,
    routes.walmartLocation,
    routes.loyaltyChallengeDetails,
    // skip forproduct details page redesign work
    ...(shouldSkipProductDetailsPage ? [new RegExp(`^${routes.menu}/(item|picker|combo)-`)] : []),
    new RegExp(`${routes.orderConfirmation}/${UUID_REGEX_STRING}`),
  ];

  if (footerComponent) {
    return footerComponent;
  } else if (mobileRoutesWithoutBottomNavbar.some(route => !!pathname.match(route))) {
    return null;
  }

  return <>{children}</>;
};

export default LayoutBottomContainer;
